import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

// order is important, since this has more conditions it should be before "paymentHistory_SAP"
export const paymentHistory_LPG_SAP: IMcAppType = {
  name: "paymentHistory_LPG_SAP",
  path: "/my-account/billing-payment/lpg/:customerNumber",
  description: "History of payments",
  parameters: {
    required: ["customerNumber"],
    properties: { customerNumber: CommonParameters.customerNumber },
  },
  navFlow: NavFlow.STANDARD,
  title: "Bills and Payments",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.sap,
    parameters: { customerNumber: "<string>" },
  },
};

export const paymentHistory: IMcAppType = {
  name: "paymentHistory_SAP",
  path: "/my-account/billing-payment/payment-history",
  description: "History of payments",
  parameters: {
    required: ["caid"],
    properties: { caid: CommonParameters.caid },
  },
  navFlow: NavFlow.STANDARD,
  title: "Payment History",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.sap,
  },
};

// order is important, since this has more conditions it should be before "paymentHistory_KRAKEN"
export const paymentHistory_LPG_KRAKEN: IMcAppType = {
  name: "paymentHistory_LPG_KRAKEN",
  path: "/my/bills-payments/lpg/:customerNumber",
  description: "History of transactions",
  parameters: {
    required: ["customerNumber"],
    properties: { customerNumber: CommonParameters.customerNumber },
  },
  navFlow: NavFlow.STANDARD,
  title: "Bills and Payments",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.kraken,
    parameters: { customerNumber: "<string>" },
  },
};

export const paymentHistory_KRAKEN: IMcAppType = {
  name: "paymentHistory_KRAKEN",
  path: "/my/bills-payments/:accountNumber?",
  description: "History of transactions",
  parameters: {
    properties: { accountNumber: CommonParameters.accountNumber },
  },
  navFlow: NavFlow.STANDARD,
  title: "Bills and Payments",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentHistory",
    customerType: CustomerType.kraken,
  },
};
